export type MfaMethod = "totp" | "passkey" | "recovery-code";

export const METHOD_TAB: Record<MfaMethod, { label: string; icon: "shield" | "key" | "lock" }> = {
  totp: { label: "Authenticator", icon: "shield" },
  passkey: { label: "Passkey", icon: "key" },
  "recovery-code": { label: "Recovery", icon: "lock" },
};

/** The order the methods are offered in; the first one available is selected. */
export const METHOD_ORDER: MfaMethod[] = ["totp", "passkey", "recovery-code"];

/** The person's methods, in the order they are offered. */
export function sortMethods(available: MfaMethod[]): MfaMethod[] {
  return METHOD_ORDER.filter((m) => available.includes(m));
}
